import { FC } from "react";

import dynamic from "next/dynamic";

import { CropDialogProps } from "./CropDialogSsr";

// Disabled SSR to avoid memory leak caused by makeStyles
export const CropDialog = dynamic(() => import("./CropDialogSsr").then((mod) => mod.CropDialogSsr), {
  ssr: false,
}) as FC<CropDialogProps>;
